import { IModelEntity } from '@pit/core';
import { IDtoDepot } from './dto.depot.interface';
import { IDtoMandator } from './dto.mandator.interface';

export enum AppVersionUpdateNeed {

    UpdateIsOptional = 1,
    UpdateIsMandatory = 2

}

export enum AppVersionUpdateType {

    Zip = 1,
    Apk = 2,
    Both = 4

}

export interface IDtoAppVersion extends IModelEntity {

    appName?: string;
    buildNumber?: number;
    majorVersion?: string;
    minorVersion?: string;
    version?: string;

    updateNeed?: AppVersionUpdateNeed;
    updateType?: AppVersionUpdateType;

    fileDataApk?: string;
    fileDataZip?: string;

    mandator?: IDtoMandator;

    depots?: IDtoDepot[];

}
